var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceBuk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#3B5998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8281 5.15105L12.3606 5.14844C10.7125 5.14844 9.64741 6.25637 9.64741 7.97124V9.27279H8.17207C8.04474 9.27279 7.94141 9.37768 7.94141 9.5071V11.3926C7.94141 11.522 8.04474 11.6264 8.17207 11.6264H9.64741V16.3848C9.64741 16.5143 9.75074 16.6186 9.87807 16.6186H11.8027C11.9301 16.6186 12.0334 16.5138 12.0334 16.3848V11.6264H13.7582C13.8855 11.6264 13.9889 11.5215 13.9889 11.3926L13.9894 9.5071C13.9894 9.445 13.9648 9.3855 13.9221 9.34166C13.8787 9.29782 13.8198 9.27279 13.7587 9.27279H12.0334V8.16955C12.0334 7.63933 12.1581 7.37005 12.8392 7.37005H13.8276C13.9549 7.37005 14.0583 7.26516 14.0583 7.13626V5.38536C14.0583 5.25593 13.9555 5.15157 13.8281 5.15105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBuk);
export default __webpack_public_path__ + "static/media/faceBuk.15035a9014b0c576ed0873d3e81e021e.svg";
export { ForwardRef as ReactComponent };